"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _decorators = require("decorators");

var _messageServer = require("message-server");

var _class;

var TinCan = (_class =
/*#__PURE__*/
function (_Activity) {
  babelHelpers.inherits(TinCan, _Activity);

  function TinCan() {
    babelHelpers.classCallCheck(this, TinCan);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(TinCan).apply(this, arguments));
  }

  babelHelpers.createClass(TinCan, [{
    key: "setup",
    value: function setup(sessionId) {
      var _this = this;

      var r,
          isGood = false,
          dt;
      Object.assign(this, {
        sessionId: sessionId
      });
      if (r = /MSIE (\d+\.\d+)/.exec(navigator.userAgent)) isGood = Number(r[1]) >= 9.0;
      if (!isGood && /Trident/.test(navigator.userAgent) && /rv:/.test(navigator.userAgent) && (r = /rv:(\d+\.\d+)/.exec(navigator.userAgent))) isGood = Number(r[1]) >= 9.0;
      if (!isGood && (r = /Chrome\/(\d+\.\d+)/.exec(navigator.userAgent))) isGood = Number(r[1]) >= 17.0;
      if (!isGood && /Safari\//.test(navigator.userAgent) && (r = /Version\/(\d+\.\d+)/.exec(navigator.userAgent))) isGood = Number(r[1]) >= 5.1;

      if (!isGood) {
        this.$('#browser-not-supported').removeClass('hidden');
        this.$('.center-block').addClass('hidden');
        this.addEventListener('startActivity', function (event) {
          event.preventDefault();
          return false;
        });
        return;
      }

      window.DoCPExit = this._doCPExitHandler;
      this.showStartActivityButton();
      this.addEventListener('startActivityButtonClick', function () {
        return _this.startActivity();
      });
      this.addEventListener(this.readOnly || this._isEditing ? 'startedActivity' : 'startActivity', function () {
        _this.useExistingActivity();

        _this.$('.section-item.description, .section-item.media-object').addClass('hidden');

        _this.$('.section-item.tincan-content').removeClass('hidden');

        _this.$('.center-block:has(#start-activity-button)').addClass('hidden');

        $(window).trigger('resize');
      });
      this.addEventListener('startedActivity', this._startTinCanActivity);
      this.addEventListener('endedActivity', function () {
        return _this.activityComplete();
      });
      if (this.readOnly) this.activityComplete();
      if (this._isEditing) this.startActivity();
    }
  }, {
    key: "_startTinCanActivity",
    value: function _startTinCanActivity(event) {
      var _this2 = this;

      if (this._isEditing) {
        this.setupResize('iframe');
        var doc = this.$('#tincan')[0].contentWindow.document;
        doc.write("\n\t\t\t\t<html>\n\t\t\t\t\t<head>\n\t\t\t\t\t\t<style type='text/css'>\n\t\t\t\t\t\t\t@import '/admin/platform/fonts/stylesheet.css';\n\t\t\t\t\t\t\tbody {\n\t\t\t\t\t\t\t\tbackground: #264771;\n\t\t\t\t\t\t\t\tcolor: #ddd;\n\t\t\t\t\t\t\t\tfont-family: Oxygen;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\th1 {\n\t\t\t\t\t\t\t\tfont-size: 48px;\n\t\t\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t\t\t\tposition: fixed;\n\t\t\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\t\t\ttransform: translateY(-50%);\n\t\t\t\t\t\t\t\tleft: 0;\n\t\t\t\t\t\t\t\tright: 0;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t</style>\n\t\t\t\t\t</head>\n\t\t\t\t\t<body>\n\t\t\t\t\t\t<h1>Your activity content here</h1>\n\t\t\t\t\t</body>\n\t\t\t\t</html>\n\t\t\t");
        doc.close();
        return;
      }

      $.get("data/lrs/".concat(event.activity.statementID, "/resources/tincan.xml"), function (xml) {
        var root = $(xml).find('activity[id]').attr('id');

        if (!_this2.readOnly) {
          var listener = new EventSourceImpl("".concat(_messageServer.message_server_url, "/statements-").concat(event.activity.statementID));
          var ended = false;

          listener.onmessage = function (event) {
            if (ended) return;

            if (event.type == 'created') {
              var st = JSON.parse(event.data);

              if ((!st.object.objectType || st.object.objectType == 'Activity') && st.object.id == root) {
                var isComplete = false,
                    isSuccess = null;

                if (st.result && st.result.completion) {
                  isComplete = true;
                  if ('success' in st.result) isSuccess = st.result.success;
                } else if (st.verb.id == 'http://adlnet.gov/expapi/verbs/passed' || st.verb.id == 'http://adlnet.gov/expapi/verbs/failed' || st.verb.id == 'http://adlnet.gov/expapi/verbs/completed') {
                  isComplete = true;
                }

                if (isSuccess === null) {
                  if (st.verb.id == 'http://adlnet.gov/expapi/verbs/failed') isSuccess = false;else isSuccess = true;
                }

                if (isComplete) {
                  var d = {
                    id: st.id,
                    success: isSuccess
                  };

                  if (st.result) {
                    if (st.result.score) {
                      d.points = st.result.score.scaled * 100;
                      d.possiblePoints = 100;
                    }
                  }

                  _this2.endActivity(d);

                  ended = true;
                }
              }
            }
          };

          listener.start();
          $(window).on('focus', function () {
            if (!ended) {
              var xhr = new XMLHttpRequest();
              var sid = _this2.sessionId;
              xhr.open("GET", "data/lrs/".concat(event.activity.statementID, "/api/statements?activity=").concat(encodeURIComponent(root)), true);
              xhr.setRequestHeader('X-Experience-API-Version', '1.0.1');
              if (sid) xhr.setRequestHeader('Authorization', "SWP ".concat(sid));else // We really don't care here.
                xhr.setRequestHeader("Authorization", "SWP-Session cookie");

              xhr.onreadystatechange = function () {
                if (!ended && xhr.readyState == 4) {
                  var stList = JSON.parse(xhr.responseText);
                  stList.statements.forEach(function (st) {
                    if (ended) return;

                    if ((!st.object.objectType || st.object.objectType == 'Activity') && st.object.id == root) {
                      var isComplete = false,
                          isSuccess = null;

                      if (st.result && st.result.completion) {
                        isComplete = true;
                        if ('success' in st.result) isSuccess = st.result.success;
                      } else if (st.verb.id == 'http://adlnet.gov/expapi/verbs/passed' || st.verb.id == 'http://adlnet.gov/expapi/verbs/failed' || st.verb.id == 'http://adlnet.gov/expapi/verbs/completed') {
                        isComplete = true;
                      }

                      if (isSuccess === null) {
                        if (st.verb.id == 'http://adlnet.gov/expapi/verbs/failed') isSuccess = false;else isSuccess = true;
                      }

                      if (isComplete) {
                        var d = {
                          id: st.id,
                          success: isSuccess
                        };

                        if (st.result) {
                          if (st.result.score) {
                            d.points = st.result.score.scaled * 100;
                            d.possiblePoints = 100;
                          }
                        }

                        _this2.endActivity(d);

                        ended = true;
                      }
                    }
                  });
                }
              };

              xhr.send();
            }
          });
        }

        _this2.$('#tincan').attr('data-activity-id', event.activity.statementID);

        var w = _this2.$('#tincan');

        setTimeout(function () {
          w.attr('src', "data/lrs/".concat(event.activity.statementID, "/resources/.launch"));
        }, 0);

        _this2.setupResize('iframe');
      });
    }
  }, {
    key: "_doCPExitHandler",
    value: function _doCPExitHandler() {
      if (this._isEditing) return;
      var path = "data/lrs/".concat(this.startActivityState.statementID, "/resources/goodbye.html");
      this.$('#tincan')[0].contentWindow.location.href = path;
    }
  }]);
  return TinCan;
}(_base.default), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "_startTinCanActivity", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_startTinCanActivity"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "_doCPExitHandler", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "_doCPExitHandler"), _class.prototype)), _class);
exports.default = TinCan;